import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiCloseButtonComponent } from './ui-close-button.component';
import { TranslationModule } from 'src/app/modules/translation.module';
@NgModule({
	declarations: [
		UiCloseButtonComponent
	],
	exports: [
		UiCloseButtonComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		TranslationModule
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA
	]
})
export class UiCloseButtonModule { }
